import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../environments/environment.development';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const isLoggenin = JSON.parse(sessionStorage.getItem(`sharedData@${environment.appName}`) || '{}');
  if (isLoggenin && isLoggenin.user && isLoggenin.user.token) {
    //---------------- POS Kitchen and "POS Kitchen Manager Role Guard start ------------------
    if( (isLoggenin.user.rolename === "POS Dispatcher" || isLoggenin.user.rolename ===  "POS Kitchen") 
      && state.url == "/" ){
      router.navigate(['/separate-kitchen']);
      return false; // Prevent the default home route navigation
    }else if( (isLoggenin.user.rolename === "POS Kitchen Manager" ) && state.url == "/" ){
      router.navigate(['/kitchen-status']);
      return false; // Prevent the default home route navigation
    }
    //---------------- POS Kitchen and "POS Kitchen Manager Role Guard start ------------------
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};

export const authGuarForLogin: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const isLoggenin = JSON.parse(
    sessionStorage.getItem(`sharedData@${environment.appName}`) || '{}'
  );

  if (isLoggenin && isLoggenin.user && isLoggenin.user.token) {
    router.navigate(['']);
    return false;
  } else {
    return true;
  }
};

export const authGuardForKitchen: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const isLoggenin = JSON.parse( sessionStorage.getItem(`sharedData@${environment.appName}`) || '{}'
  );
 
  if (isLoggenin.user) {
    if (isLoggenin.user.rolename === "POS Kitchen") { 
      router.navigate(['/separate-kitchen']);
      return true; 
    }else{
      router.navigate(['/']);
      return false; // Block navigation to home
    }

    return true; // Allow access to the kitchen-status page or any other route
  }
  router.navigate(['/login']);
  return false;
};
